var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 74,
    viewBox: "0 0 122 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.65 72.822C111.912 73.3085 112.518 73.4908 113.005 73.2293L120.932 68.9674C121.418 68.7058 121.6 68.0995 121.339 67.6131C121.077 67.1266 120.471 66.9443 119.985 67.2058L112.938 70.9942L109.15 63.948C108.889 63.4616 108.282 63.2792 107.796 63.5408C107.309 63.8023 107.127 64.4086 107.389 64.8951L111.65 72.822ZM1.0965 5.11293C28.3819 2.46758 50.1066 1.54737 67.0573 2.60932C84.0274 3.67248 96.095 6.71689 104.158 11.9028C112.153 17.0449 116.294 24.3453 117.317 34.2011C118.347 44.1238 116.214 56.6291 111.574 72.0605L113.489 72.6364C118.15 57.134 120.378 44.3198 119.306 33.9946C118.227 23.6024 113.801 15.7265 105.24 10.2207C96.7476 4.75871 84.2706 1.6838 67.1824 0.613237C50.075 -0.45853 28.228 0.473122 0.903502 3.12227L1.0965 5.11293Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow1.4c26b2beaa0ba61b68cc81dd17468739.svg";
export { ForwardRef as ReactComponent };